<template>
    <div class='MhMultipleSelect'>
      <el-select v-model="value1" :disabled="mReadOnly" :clearable="mClearAble" multiple filterable>
        <el-select-options :item="mMapValues"></el-select-options>
      </el-select>
    </div>
</template>

<script>
import ElSelectOptions from '@/components/base/ElSelectOptions.vue'
export default {
  name: 'MhMultipleSelect',
  props: ['mObj', 'mProp', 'mReadOnly', 'mClearAble', 'mMapValues'],
  data () {
    return {
      flag: false,
      value1: []
    }
  },
  computed: {
    mPropValue () {
      return this.mObj[this.mProp]
    }
  },
  components: {
    ElSelectOptions
  },
  methods: {
  },
  watch: {
    // mPropValue (newVal, oldVal) {
    //   if (!this.flag) {
    //     console.log('2222222', this.flag, newVal)
    //     if (newVal === '') {
    //       this.value1 = []
    //     } else {
    //       this.value1 = newVal.split(';')
    //     }
    //   }
    // },
    mPropValue (newVal, oldVal) {
      if (newVal === '') {
        this.value1 = []
      } else {
        this.value1 = newVal.split(';')
      }
    },
    value1: {
      handler (newObj, oldObj) {
        const that = this
        that.flag = true
        that.mObj[that.mProp] = newObj.join(';')
        setTimeout(function () {
          that.flag = false
        }, 500)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>

</style>
